import debug from 'debug';
import * as React from 'react';
import { FC } from 'react';
import { Constants } from '../../../../../Constants';
import { useBucket } from '../../../../../libs/hooks/useBucket';
import { useAppSelector } from '../../../../../redux/app/hooks';
import { RootState } from '../../../../../redux/app/store';
import { BucketItem } from '../../../../../redux/features/buckets/BucketsState';
import { BucketsTreeView } from './BucketTreeView';

interface BucketPopoverProps {
    chatId: string;
    targetRef?: React.RefObject<HTMLTextAreaElement>;
}

export const BucketPopoverContent: FC<BucketPopoverProps> = ({ chatId }) => {
    const [searchText, setSearchText] = React.useState<string>('');
    const [filteredItems, setFilteredItems] = React.useState<BucketItem[]>([]);
    const { activeUserInfo } = useAppSelector((state: RootState) => state.app);
    const { Buckets } = useAppSelector((state: RootState) => state.buckets);
    const emailAddress = activeUserInfo?.email ?? '';
    const user = `${emailAddress}`;
    const log = debug(Constants.debug.root).extend('bucket-selection-menu');
    const bucket = useBucket();

    React.useEffect(() => {
        if (Buckets.length < 1) {
            void bucket.getBuckets(user).catch((e) => {
                log('error getting splash guidance', e);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        setFilteredItems(Buckets);
    }, [Buckets]);

    React.useEffect(() => {
        if (searchText) {
            const searchItems = Buckets.filter((d) => d.title.toLowerCase().includes(searchText.toLowerCase()));

            const parents = searchItems.filter((i) => i.parent?.id);

            if (parents.length > 0) {
                parents.forEach((item) => {
                    const parent = item.parent;
                    if (parent && !searchItems.some((a) => a.id === parent.id)) {
                        searchItems.push(parent);
                    }
                });
            }

            setFilteredItems(searchItems);
        }
        if (searchText === '') {
            setFilteredItems(Buckets);
        }
    }, [Buckets, searchText]);

    return (
        <div className="p-1 rounded-box w-full">
            <div>
                <input
                    type="search"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg outline-none focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Search authoritive documents..."
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation(); // window click event closes the menu if open so we need to stop that
                    }}
                    onChange={(e) => {
                        e.preventDefault();
                        e.stopPropagation(); // window click event closes the menu if open so we need to stop that

                        setSearchText(e.target.value);
                    }}
                />
            </div>
            <BucketsTreeView chatId={chatId} items={filteredItems} collapseParents={searchText.length > 0} />
        </div>
    );
};
